import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.medium};
  padding-right: 29px;
  position: relative;
  height: 21px;
  cursor: pointer;

  &:hover {
    &:before {
      border-color: ${Variables.colors.primary_vivid};
    }
  }

  &:before {
    content: " ";
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    border: 1px solid;
    ${props => {
      if (props.checked) {
        if (props.checkedColor) {
          return `
					border-color: ${Variables.colors.tertiary_700};
					background-color: ${Variables.colors.tertiary_700};
				`;
        } else {
          return `
					border-color: ${Variables.colors.primary_vivid};
					background-color: ${Variables.colors.primary_vivid};
				`;
        }
      } else {
        return `
					border-color: ${Variables.colors.complementary_500};
					background-color: ${Variables.colors.complementary};
				`;
      }
    }}
  }

  ${props => {
    if (props.checked) {
      return `
				&:after {
					content: ' ';
					position: absolute;
					right: 7px;
					top: 1px;
					width: 4px;
					height: 12px;
					border-right: 2px solid ${Variables.colors.complementary};
					border-bottom: 2px solid ${Variables.colors.complementary};
					background-color: transparent;
					-webkit-transform: rotate(45deg);
					-moz-transform: rotate(45deg);
					-ms-transform: rotate(45deg);
					-o-transform: rotate(45deg);
					transform: rotate(45deg);
				}
			`;
    }
  }}
  ${props => {
    if (props.disabled) {
      return `
      &:before {
        border-color: ${Variables.colors.complementary_450};
        background-color: ${Variables.colors.complementary_450};
        opacity: 0.5;
        cursor: default;
      }
      `;
    }
  }}
`;
